import React from "react"

export default () => {
  return <div className="footer">
    <div>
      Copyright © 2026 <strong>ReadyShare Admin Panel</strong> All rights reserved.
    </div>
  </div>
}